import clsx from "clsx";
import { Icon } from "../../Icon";
import styles from "./HelpIcon.module.css";

interface HelpIconProps {
  color?: "grey" | "white" | "blue";
  className?: string;
  ref?: React.RefObject<HTMLDivElement>;
}

export const HelpIcon: React.FC<HelpIconProps> = ({
  color,
  className,
  ref,
}) => {
  return (
    <div
      ref={ref}
      className={clsx(
        styles.help,
        color !== undefined && styles[color],
        className,
      )}
    >
      <Icon className={styles.icon} name="question_24px_light" />
    </div>
  );
};
